export { urlConstructor } from 'utilities/route';

const subRoute = (basePath, subPath) => basePath + subPath;

export const externalRoutes = {
  NEW_JOB_FORM_FEEDBACK:
    'https://docs.google.com/forms/d/e/1FAIpQLSf09aGZO8WUiYDyIFu0enMIHQW-acSpmTkC2DWb87rahtz_cA/viewform',
  ALL_JOBS_FEEDBACK:
    'https://docs.google.com/forms/d/e/1FAIpQLSeVOTqriIZhcYgl3rKWgpdszb54m22Zo5Ue3j19PTLJz7cruA/viewform',
  TIME_AND_ATTENDANCE_FEEDBACK:
    'https://docs.google.com/forms/d/e/1FAIpQLSfukXjk3Eb202tXO8FWdnIzRTTNU7dm0SktAFaeMCifM21IqA/viewform?usp=sf_link ',
  TRANSACTIONS_FEEDBACK:
    'https://docs.google.com/forms/d/e/1FAIpQLSfdT5F1zHqQ7uhk-1V-dOGWRWvKHFCi3T-CX5B4ck0L9zEBfw/viewform?usp=sf_link',
  GOOGLE_CALENDAR: 'https://www.google.com/calendar/render',
  SUPPORT: 'https://help.wonolo.com/requestors/s/contactsupport',
  SAME_WORKERS_POLICY_W2: 'https://info.wonolo.com/long-term-w2/',
  SAME_WORKERS_POLICY_1099: 'https://info.wonolo.com/lte/',
  DISPUTE_LINK: 'https://support-business.wonolo.com/contact/customer-job-dispute-ryq6cp0Rxx',
  FAQ: 'https://support-business.wonolo.com',
  TEAMS_HELP_LINK: 'https://support-business.wonolo.com/en_us/what-is-a-preferred-team-Hypfm4o6eg',
  RAMP_UP_HELP_LINK: 'https://support-business.wonolo.com/en_us/how-can-i-create-job-positions-Hk2lWNiael',
};

export const urlMap = (() => {
  const HOME = '/';
  const NEW_JOB = '/job_requests/new';
  const EDIT_JOB = '/job_requests/edit/:id';
  const JOBS = '/jobs'; // manage jobs

  return {
    FLAGGED_ROUTE: '/flagged_route',

    HOME,
    RAILS_SIGNIN: '/users/sign_in',
    SIGNIN: '/signin',
    SIGNOUT: '/signout',
    FORGOT: '/forgotPassword',

    MESSAGE_INBOX: '/messages',
    MESSAGE_WINDOW: '/jobs/:id/messages',

    MY_INFO: '/employers/:id',
    EDIT_REQUESTOR_INFO: '/employers/:id/edit',
    ADD_REQUESTOR: '/employers/new',
    CHANNEL_SETTINGS: '/employers/:id/channel_settings',
    WANDAS: '/wandas',
    COMPANY_PAGE: '/customers/:id',
    EDIT_COMPANY_SETTINGS: '/customers/:id/edit',

    TEAMS: '/employers/:id/teams',
    TEAMS_FORM: '/employers/:id/teams/:teamId/:type',
    TEAM_DETAILS: '/employers/:id/teams/:teamId/edit',

    WONOLOERS: '/workers/list_for_employer',
    WORKERS_LIST: '/workers/list_of_workers',
    WORKER_SCHEDULE: '/workers/schedule',
    WORKERS: '/workers/:id',

    /* IMPORT JOBS */
    JOB_REQUESTS_IMPORT: '/job_requests/imported_list',
    JOB_REQUEST_IMPORTED_FILE: '/job_requests/imported_list/:id',

    ACTIVE_JOBS: '/job_requests/active',
    JOB_REQUESTS: '/job_requests/:id',
    JOBS,
    JOBS_EDIT: '/jobs/:id/edit',
    PINS: '/pins',
    MESSAGES: '/messages',
    /* RAILS DEPENDENT ROUTES REMOVE ONCE UPDATED in edit.html.slim and new.html.slim */
    UPLOAD_JOB_REQUESTS: '/api/requestor/job_requests/import',
    JOB_REQUEST_DOWNLOAD_IMPORT_TEMPLATE:
      '/job_requests/download_sample_file?format=csv',
    ATTENDANCE_REPORTS_EXPORT_LEGACY:
      '/employers/time_and_attendance?from_date=:fromDate&to_date=:toDate&keyword=:keyword&commit=:commit&graphql=:graphql&columns=:columns&statuses=:status',
    EDIT_TEMPLATE_LEGACY: '/job_requests/:id/edit', //  routes to rails sanitize after frontend is liberated
    JOB_DETAILS_LEGACY: '/jobs/:id/edit',
    JOB_REQUEST_DETAILS_LEGACY: '/job_requests/:id',
    JOB_REQUEST_DRAFTS_NEW: '/job_requests/drafts',
    JOB_REQUEST_NEW: '/job_requests/new',
    JOB_REQUEST_TO_RATE: '/job_requests/to_rate',
    JOBS_MESSAGES_LEGACY: '/jobs/:id/messages',
    MANAGE_JOBS: '/jobs',
    NEW_JOB_LEGACY: '/job_requests/new',
    NEW_JOB_REPOST_LEGACY: '/job_requests/new/from/:id',
    NEW_JOB_FROM_SCRATCH_LEGACY: '/post_job/new',
    NEW_JOB_EDIT_LEGACY: '/post_job/:id',
    RAILS_TIME_AND_ATTENDANCE: '/employers/time_and_attendance',
    RAILS_TIME_AND_ATTENDANCE_ROSTER_REPORT:
      '/employers/time_and_attendance?trigger=roster',
    RAILS_NEW_REQUESTOR: '/employers/new',
    EDIT_REQUESTOR_INFO_LEGACY: '/employers/:id/edit',
    /* ***** ***** */

    NEW_JOB,
    NEW_JOB_FROM_COPY: subRoute(NEW_JOB, '/from_copy/:id'),
    NEW_JOB_FROM_REPOST: subRoute(NEW_JOB, '/from_repost/:id'),
    NEW_JOB_FROM_SCRATCH: subRoute(NEW_JOB, '/:id'),
    NEW_JOB_FROM_TEMPLATE: subRoute(NEW_JOB, '/from_template/:id'),
    NEW_JOB_TEMPLATES: '/job_requests/templates',

    NEW_TEMPLATE: '/job_requests/templates/create/:id',
    EDIT_TEMPLATE: '/job_requests/templates/edit/:id',
    EDIT_TEMPLATE_SECTION: subRoute(
      '/job_requests/templates/edit/:id',
      '/:section'
    ),

    EDIT_JOB,
    EDIT_JOB_SECTION: subRoute(EDIT_JOB, '/:section'),

    TEMPLATE_LIST: '/job_requests/template',

    REPORT_USAGE: '/usage',
    REPORT_TRANSACTION: '/transactions',
    TRANSACTION_DETAILS: '/transactions/:id',
    REPORT_ATTENDANCE_ALL: '/reports/jobs',
    REPORT_ATTENDANCE: '/reports/jobs/:report?',
    ACCOUNT_REPORTS: '/reports/transactions',

    /* VENUES */
    // Using naming scheme ENTITY_VERB
    VENUES: '/venues',
    VENUE_CREATE: '/venues/create',
    VENUE_DETAILS: '/venues/:id',
    VENUE_EDIT: '/venues/:id/edit',

    /* POSITIONS */
    POSITIONS: '/positions',
    POSITIONS_CONFIGURATOR: '/positions/configure/:id',
    POSITIONS_CREATE: '/positions/create',

    FAQ: '/faq',
    CONTACT: '/contact',

    MAGIC: '/job_requests/thank_you_for_posting/:id/:category/:zip/:name',
    TRYOUT_CONFIRMATION: '/job_requests/tryout_confirmation/:badgeId',

    INVOICE_REPORT: '/reports/invoice_report/:report?',
    INVOICE_REPORT_ALL: '/reports/invoice_report',
    SUMMARY_REPORT_ALL: '/reports/summary-report',
    ENTERPRISE_OVERVIEW: '/reports/enterprise_overview',
    SUMMARY_REPORT: '/reports/summary-report/:report?',
    SUMMARY_REPORT_CSV_EXPORT:
      '/reporting/summary-report.csv?from_date=:fromDate&to_date=:toDate&search=:search&status=:status&venue_ids=:venueIds&columns=:columns',
    DASHBOARD: '/dashboard',
    NOTIFICATION_PREFERENCES: '/settings/notifcation_preferences',

    JOBS_REPORT: '/job_reports',
    JOB_REPORT_MANAGE: '/job_reports/:id',
    JOB_REPORT_NEW: '/job_reports/create',
    JOBS_REPORT_TIME_AND_ATTENDANCE: '/reports/time_and_attendance',
    JOBS_REPORT_ROSTER: '/job_reports/roster',

    SCHEDULES: '/schedules',
    SCHEDULES_CREATE: '/schedules/create',
    SCHEDULES_EDIT: '/schedules/:id/edit',

    MANAGE_SHIFTS: '/manage_shifts',
    MANAGE_SHIFTS_CREATE: '/manage_shifts/create',
    MANAGE_SHIFTS_EDIT: '/manage_shifts/:id',
    MANAGE_SHIFTS_COPY: '/manage_shifts/:id/copy',

    // REST routes for upload and download
    UPLOAD_REQUESTORS: '/employers/import',
    REQUESTORS_DOWNLOAD_IMPORT_TEMPLATE:
      '/employers/download_sample_file?format=csv',

    TERMS_OF_SERVICE: '/terms_of_service',
    RESET_PASSWORD: '/reset_password',

    CREATE_MODULAR_ORDER: '/post', // @TODO: ask product as to what the actual url should be
    MODULAR_ORDER_FORM: '/mo-flow', // @TODO: ask product as to what the actual url should be
    MODULAR_ORDER_FORM_RETURNING: '/mo-flow/:positionId', // @TODO: ask product as to what the actual url should be

    NOT_FOUND: '/not_found',
  };
})();

export const SIGNIN_PAGES = [
  urlMap.SIGNIN,
  urlMap.FORGOT,
  urlMap.RESET_PASSWORD,
  urlMap.TERMS_OF_SERVICE,
];
